/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateDeliveryParcel201ResponseAllOfData } from './CreateDeliveryParcel201ResponseAllOfData';
import {
    CreateDeliveryParcel201ResponseAllOfDataFromJSON,
    CreateDeliveryParcel201ResponseAllOfDataFromJSONTyped,
    CreateDeliveryParcel201ResponseAllOfDataToJSON,
} from './CreateDeliveryParcel201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateDeliveryParcel201Response
 */
export interface CreateDeliveryParcel201Response {
    /**
     * 
     * @type {CreateDeliveryParcel201ResponseAllOfData}
     * @memberof CreateDeliveryParcel201Response
     */
    data: CreateDeliveryParcel201ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof CreateDeliveryParcel201Response
     */
    meta: object;
}

/**
 * Check if a given object implements the CreateDeliveryParcel201Response interface.
 */
export function instanceOfCreateDeliveryParcel201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function CreateDeliveryParcel201ResponseFromJSON(json: any): CreateDeliveryParcel201Response {
    return CreateDeliveryParcel201ResponseFromJSONTyped(json, false);
}

export function CreateDeliveryParcel201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDeliveryParcel201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateDeliveryParcel201ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function CreateDeliveryParcel201ResponseToJSON(value?: CreateDeliveryParcel201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateDeliveryParcel201ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

